export function LoadingPage() {
  return (
    <div className="absolute top-0 right-0 left-0 bottom-0 bg-shark-500">
      <div className=" animate-pulse grid place-items-center">Loading</div>
    </div>
  );
}
